import React from "react";
import { connect } from "react-redux";
import Header from "./Header.js";
import { ProgressSpinner } from "primereact/progressspinner";
import LoginBox from "./LoginBox.js";
import { Dialog } from "primereact/dialog";
import momentJalaali from "moment-jalaali";
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";
import Server from "./Server.js";

class Turnover extends React.Component {
  constructor(props) {
    super(props);

    this.Server = new Server();

    this.state = {
      visibleLoader: false,
      branches: this.props.branches,
      untilDate: new Date(),
      fromDate: new Date(),
    };
  }

  ConvertNumToFarsi(text) {
    var id = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    if (!text) return text;
    return text.toString().replace(/[0-9]/g, function (w) {
      return id[+w];
    });
  }
  componentDidMount() {
    let param = {
      token: localStorage.getItem("api_token"),
    };
    this.setState({
      loading: 1
    })
    let SCallBack = (response) => {
        this.setState({
          userId: response.data.authData.userId,
        },()=>{
          if (this.props.mobile) {
            this.firtsAcction();
          } else {
            this.setState({
              showLogin: true,
            });
          }
        })
    };
    let ECallBack = (error) => {
      this.setState({
        showLogin: 0
      })
      console.log(error)
    }
    this.Server.send("MainApi/checktoken", param, SCallBack, ECallBack)
    
  }
  firtsAcction() {
    let branchNames = [];
    let count = 0;
    if (this.state.branches && this.state.branches.length > 0) {
      for (let i = 0; i < this.state.branches.length; i++) {
        count++;
        branchNames.push({
          code: count,
          _id: this.state.branches[i]._id,
          name: this.state.branches[i].name,
        });
      }
    }
    this.setState({
      branchNames: branchNames,
    });
    if (this.props.shop) {
      this.getShopCreditPayment();
    } else {
      this.getCreditPayment();
    }
  }
  getShopCreditPayment() {
    let that = this;
    var mobile = null;
    //branches
    this.setState({
      visibleLoader: true,
    });
    let SCallBack = function (response) {
      that.setState({
        Gardesh: response.data.result,
        visibleLoader: false,
      });
    };
    let ECallBack = function (error) {
      that.setState({
        visibleLoader: false,
      });
    };
    this.setState({
      visibleLoader: true,
    });
    let shopIds = [];
    shopIds.push(this.props.shopId);
    if (this.props.branches && this.props.branches.length > 0) {
      for (let i = 0; i < this.props.branches.length; i++) {
        shopIds.push(this.props.branches[i]._id);
      }
    }
    if (shopIds.length > 1) {
      this.Server.send(
        "MainApi/getShopCreditPayment",
        {
          shopId: shopIds,
          hasBranch: 1,
          fromDate:
          this.state.fromDate && this.state.fromDate.year
            ? `${this.state.fromDate.year}/${this.state.fromDate.month}/${this.state.fromDate.day}`
            : null,
        untilDate:
          this.state.untilDate && this.state.untilDate.year
            ? `${this.state.untilDate.year}/${this.state.untilDate.month}/${this.state.untilDate.day}`
            : null,
        },
        SCallBack,
        ECallBack
      );
    } else {
      this.Server.send(
        "MainApi/getShopCreditPayment",
        {
          shopId: this.props.shopId,
          fromDate:
          this.state.fromDate && this.state.fromDate.year
            ? `${this.state.fromDate.year}/${this.state.fromDate.month}/${this.state.fromDate.day}`
            : null,
        untilDate:
          this.state.untilDate && this.state.untilDate.year
            ? `${this.state.untilDate.year}/${this.state.untilDate.month}/${this.state.untilDate.day}`
            : null,
        },
        SCallBack,
        ECallBack
      );
    }
  }
  getCreditPayment() {
    let that = this;
    var userId = this.state.userId;
    this.setState({
      visibleLoader: true,
    });
    let SCallBack = function (response) {
      that.setState({
        Gardesh: response.data.result,
        visibleLoader: false,
      });
    };
    let ECallBack = function (error) {
      that.setState({
        visibleLoader: false,
      });
    };
    this.setState({
      visibleLoader: true,
    });
    this.Server.send(
      "MainApi/getCreditPayment",
      {
        limit: 0,
        username: userId,
        fromDate:
          this.state.fromDate && this.state.fromDate.year
            ? `${this.state.fromDate.year}/${this.state.fromDate.month}/${this.state.fromDate.day}`
            : null,
        untilDate:
          this.state.untilDate && this.state.untilDate.year
            ? `${this.state.untilDate.year}/${this.state.untilDate.month}/${this.state.untilDate.day}`
            : null,
      },
      SCallBack,
      ECallBack
    );
  }
  render() {
    return (
      <div>
        <Dialog
          header="ورود به سامانه"
          visible={this.state.showLogin}
          maximized={true}
          closable={true}
          resizable={false}
          draggable={false}
          onHide={() => {
            if (this.props.mobile) {
              this.setState({
                showLogin: false,
              });
              this.firtsAcction();
            } else {
              window.history.back();
            }
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              
              flexDirection: "column",
            }}
          >
            <LoginBox
              appData={this.props.appData}
              AfterLogin={() => {
                this.setState({
                  showLogin: false,
                });
                this.firtsAcction();
              }}
            />
          </div>
        </Dialog>
        {!this.props.shop && (
          <Header
            navigation={this.props.navigation}
            ComponentName="گردش حساب "
            goBack={true}
          />
        )}

        <div  style={{minHight:400}}>
          {this.state.branchNames && this.state.branchNames.length > 0 && (
            <div
              style={{
                display: "flex",
                direction: "rtl",
                flexWrap: "wrap",
                marginBottom: 20,
                background: "bisque",
                padding: 10,
              }}
            >
              <div
                style={{
                  width: "100%",
                  textAlign: "right",
                  fontFamily: "iranyekanwebmedium",
                  marginRight: 5,
                  fontSize: 14,
                }}
              >
                {" "}
                لیست شعب
              </div>
              {this.state.branchNames &&
                this.state.branchNames.map((item, index) => {
                  return (
                    <div
                     key={index}
                      style={{
                        textAlign: "right",
                        fontFamily: "iranyekanwebmedium",
                        marginRight: 5,
                        fontSize: 12,
                      }}
                    >
                      {item.code} - {item.name}
                    </div>
                  );
                })}
            </div>
          )}

          <div
            style={{display:'flex',justifyContent:'space-around',marginTop:20}}
          >
            <DatePicker
              date={this.state.untilDate}
              format={"DD-MM-YYYY"}
              onChange={(value) => {
                this.setState({ untilDate: value });
                setTimeout(() => {
                  if (this.state.visibleLoader || !this.props.mobile) return;
                  if (this.props.shop) {
                    this.getShopCreditPayment();
                  } else {
                    this.getCreditPayment();
                  }
                }, 0);
              }}
              locale="fa"
              formatInputText={() => {
                if (!this.state.untilDate.day) return '';
                return ` ${this.state.untilDate.day} / ${this.state.untilDate.month} / ${this.state.untilDate.year} `;
              }}
              inputPlaceholder={"تا تاریخ"}
            />
            <DatePicker
              date={this.state.fromDate}
              format={"DD-MM-YYYY"}
              onChange={(value) => {
                this.setState({ fromDate: value });
                setTimeout(() => {
                  if (this.state.visibleLoader || !this.props.mobile) return;
                  if (this.props.shop) {
                    this.getShopCreditPayment();
                  } else {
                    this.getCreditPayment();
                  }
                }, 0);
              }}
              formatInputText={() => {
                if (!this.state.fromDate.day) return '';
                return ` ${this.state.fromDate.day} / ${this.state.fromDate.month} / ${this.state.fromDate.year} `;
              }}
              locale="fa"
              inputPlaceholder={"از تاریخ"}
            />
            
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: 10,
            }}
          >
            <div
              style={{
                backgroundColor: "#fff",
                width: "100%",
                textAlign: "right",
              }}
            >
              <div
                style={{
                  textAlign: "right",
                  fontFamily: "iranyekanwebmedium",
                  marginRight: 5,
                  fontSize: 12,
                  backgroundColor: "#eee",
                  width: "100%",
                }}
              >
                تمامی مبالغ به ریال است
              </div>
            </div>
          </div>
          {!this.state.visibleLoader ? (
            <div>
              {!this.props.shop ? (
                <div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row-reverse",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginTop: 10,
                      backgroundColor: "#cdd8df",
                    }}
                  >
                    <div style={{ width: "20%", textAlign: "center" }}>
                      <span
                        style={{
                          textAlign: "center",
                          fontFamily: "iranyekanwebmedium",
                          fontSize: 11,
                        }}
                      >
                        مبلغ
                      </span>
                    </div>
                    <div
                      style={{
                        width: "15%",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        marginLeft: 10,
                      }}
                    >
                      <span
                        style={{
                          textAlign: "center",
                          fontFamily: "iranyekanwebmedium",
                          fontSize: 11,
                        }}
                      >
                        فروشگاه
                      </span>
                    </div>
                    <div style={{ width: "15%", textAlign: "center" }}>
                      <span
                        style={{
                          textAlign: "center",
                          fontFamily: "iranyekanwebmedium",
                          fontSize: 11,
                        }}
                      >
                        تاریخ
                      </span>
                    </div>
                    <div style={{ width: "15%", textAlign: "center" }}>
                      <span
                        style={{
                          textAlign: "center",
                          fontFamily: "iranyekanwebmedium",
                          fontSize: 11,
                        }}
                      >
                        روز
                      </span>
                    </div>
                    <div style={{ width: "15%", textAlign: "center" }}>
                      <span
                        style={{
                          textAlign: "center",
                          fontFamily: "iranyekanwebmedium",
                          fontSize: 11,
                        }}
                      >
                        توضیح
                      </span>
                    </div>
                    <div style={{ width: "20%", textAlign: "center" }}>
                      <span
                        style={{
                          textAlign: "center",
                          fontFamily: "iranyekanwebmedium",
                          fontSize: 11,
                        }}
                      >
                        وضعیت
                      </span>
                    </div>
                  </div>
                  {this.state.Gardesh &&
                    this.state.Gardesh.length > 0 &&
                    this.state.Gardesh.map((v, i) => {
                      return (
                        <div
                          key={i}
                          style={{
                            display: "flex",
                            flexDirection: "row-reverse",
                            justifyContent: "space-between",
                            alignItems: "center",
                            backgroundColor: i % 2 == 0 ? "#fff" : "#eee",
                          }}
                        >
                          <div style={{ width: "20%", textAlign: "center" }}>
                            <span
                              style={{
                                textAlign: "center",
                                fontFamily: "iranyekanwebmedium",
                                fontSize: 11,
                              }}
                            >
                              {v.Amount.toString()
                                .replace(",", "")
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </span>
                          </div>
                          <div
                            style={{
                              width: "15%",
                              textAlign: "center",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              marginLeft: 10,
                            }}
                          >
                            <span
                              style={{
                                textAlign: "center",
                                fontFamily: "iranyekanwebmedium",
                                fontSize: 11,
                              }}
                            >
                              {v.shop[0] ? v.shop[0].name : "-"}
                            </span>
                          </div>
                          <div style={{ width: "15%", textAlign: "center" }}>
                            <span
                              style={{
                                textAlign: "center",
                                fontFamily: "iranyekanwebmedium",
                                fontSize: 11,
                              }}
                            >
                              {v.Date}
                            </span>
                          </div>
                          <div style={{ width: "15%", textAlign: "center" }}>
                            <span
                              style={{
                                textAlign: "center",
                                fontFamily: "iranyekanwebmedium",
                                fontSize: 11,
                              }}
                            >
                              {v.Time}
                            </span>
                          </div>
                          <div style={{ width: "20%", textAlign: "center" }}>
                            <span
                              style={{
                                textAlign: "center",
                                fontFamily: "iranyekanwebmedium",
                                fontSize: 11,
                              }}
                            >
                              {v.desc}
                            </span>
                          </div>
                          <div style={{ width: "15%", textAlign: "center" }}>
                            {v.type == 1 ? (
                              <span
                                style={{
                                  textAlign: "center",
                                  fontFamily: "iranyekanwebmedium",
                                  fontSize: 12,
                                  color: "green",
                                }}
                              >
                                <i className="fas fa-plus-circle" />
                              </span>
                            ) : (
                              <span
                                style={{
                                  textAlign: "center",
                                  fontFamily: "iranyekanwebmedium",
                                  fontSize: 12,
                                  color: "red",
                                }}
                              >
                                <i className="fas fa-minus-circle" />
                              </span>
                            )}
                          </div>
                        </div>
                      );
                    })}
                </div>
              ) : (
                <div style={{ textAlign: "center",height:500 }}>
                  <span
                    style={{
                      textAlign: "center",
                      fontFamily: "iranyekanwebmedium",
                      fontSize: 18,
                    }}
                  >
                    آخرین تراکنش های حساب{" "}
                  </span>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row-reverse",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginTop: 10,
                      backgroundColor: "#cdd8df",
                    }}
                  >
                    <div style={{ width: "20%", textAlign: "center" }}>
                      <span
                        style={{
                          textAlign: "center",
                          fontFamily: "iranyekanwebmedium",
                          fontSize: 11,
                        }}
                      >
                        مبلغ
                      </span>
                    </div>
                    <div style={{ width: "20%", textAlign: "center" }}>
                      <span
                        style={{
                          textAlign: "center",
                          fontFamily: "iranyekanwebmedium",
                          fontSize: 11,
                        }}
                      >
                        {this.props.shop ? "خریدار" : "فروشگاه"}
                      </span>
                    </div>
                    {this.state.branches && this.state.branches.length > 0 && (
                      <div style={{ width: "10%", textAlign: "center" }}>
                        <span
                          style={{
                            textAlign: "center",
                            fontFamily: "iranyekanwebmedium",
                            fontSize: 11,
                          }}
                        >
                          شعبه
                        </span>
                      </div>
                    )}

                    <div style={{ width: "20%", textAlign: "center" }}>
                      <span
                        style={{
                          textAlign: "center",
                          fontFamily: "iranyekanwebmedium",
                          fontSize: 11,
                        }}
                      >
                        تاریخ
                      </span>
                    </div>

                    <div style={{ width: "13%", textAlign: "center" }}>
                      <span
                        style={{
                          textAlign: "center",
                          fontFamily: "iranyekanwebmedium",
                          fontSize: 11,
                        }}
                      >
                        توضیح
                      </span>
                    </div>
                    <div style={{ width: "10%", textAlign: "center" }}>
                      <span
                        style={{
                          textAlign: "center",
                          fontFamily: "iranyekanwebmedium",
                          fontSize: 11,
                        }}
                      >
                        رسید
                      </span>
                    </div>
                    <div style={{ width: "7%", textAlign: "center" }}>
                      <span
                        style={{
                          textAlign: "center",
                          fontFamily: "iranyekanwebmedium",
                          fontSize: 11,
                        }}
                      >
                        وضعیت
                      </span>
                    </div>
                  </div>
                  {this.state.Gardesh &&
                    this.state.Gardesh.length > 0 &&
                    this.state.Gardesh.map((v, i) => {
                      return (
                        <div
                          key={i}
                          style={{
                            display: "flex",
                            flexDirection: "row-reverse",
                            justifyContent: "space-between",
                            alignItems: "center",
                            backgroundColor: i % 2 == 0 ? "#fff" : "#eee",
                          }}
                        >
                          <div style={{ width: "20%", textAlign: "center" }}>
                            <span
                              style={{
                                textAlign: "center",
                                fontFamily: "iranyekanwebmedium",
                                fontSize: 14,
                              }}
                            >
                              {v.Amount.toString()
                                .replace(",", "")
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </span>
                          </div>
                          <div style={{ width: "20%", textAlign: "center" }}>
                            {this.props.shop ? (
                              <span
                                style={{
                                  textAlign: "center",
                                  fontFamily: "iranyekanwebmedium",
                                  fontSize: 11,
                                }}
                              >
                                {v.user[0] ? v.user[0].name : "-"}
                              </span>
                            ) : (
                              <span
                                style={{
                                  textAlign: "center",
                                  fontFamily: "iranyekanwebmedium",
                                  fontSize: 11,
                                }}
                              >
                                {v.shop[0] ? v.shop[0].name : "-"}
                              </span>
                            )}
                          </div>
                          {this.state.branches &&
                            this.state.branches.length > 0 && (
                              <div
                                style={{ width: "10%", textAlign: "center" }}
                              >
                                <div
                                  style={{
                                    textAlign: "center",
                                    fontFamily: "iranyekanwebmedium",
                                    fontSize: 11,
                                  }}
                                >
                                  {this.state.branchNames.filter((item) => {
                                    return item._id == v.ShopId;
                                  })[0]
                                    ? this.state.branchNames.filter((item) => {
                                        return item._id == v.ShopId;
                                      })[0].code
                                    : ""}
                                </div>
                              </div>
                            )}
                          <div style={{ width: "20%", textAlign: "center" }}>
                            <div
                              style={{
                                textAlign: "center",
                                fontFamily: "iranyekanwebmedium",
                                fontSize: 11,
                              }}
                            >
                              {v.Date}
                            </div>
                            <div
                              style={{
                                textAlign: "center",
                                fontFamily: "iranyekanwebmedium",
                                fontSize: 11,
                              }}
                            >
                              {v.Time}
                            </div>
                          </div>

                          <div style={{ width: "13%", textAlign: "center" }}>
                            <span
                              style={{
                                textAlign: "center",
                                fontFamily: "iranyekanwebmedium",
                                fontSize: 11,
                              }}
                            >
                              {v.desc}
                            </span>
                          </div>
                          <div style={{ width: "10%", textAlign: "center" }}>
                            <span
                              style={{
                                textAlign: "center",
                                fontFamily: "iranyekanwebmedium",
                                fontSize: 11,
                              }}
                            >
                              {v.resCode}
                            </span>
                          </div>
                          {v.username == "system" ? (
                            <div style={{ width: "7%", textAlign: "center" }}>
                              {v.type == 1 ? (
                                <span
                                  style={{
                                    textAlign: "center",
                                    fontFamily: "iranyekanwebmedium",
                                    fontSize: 12,
                                    color: "green",
                                  }}
                                >
                                  <i className="fas fa-plus-circle" />
                                </span>
                              ) : (
                                <span
                                  style={{
                                    textAlign: "center",
                                    fontFamily: "iranyekanwebmedium",
                                    fontSize: 12,
                                    color: "red",
                                  }}
                                >
                                  <i className="fas fa-minus-circle" />
                                </span>
                              )}
                            </div>
                          ) : (
                            <div style={{ width: "7%", textAlign: "center" }}>
                              <span
                                style={{
                                  textAlign: "center",
                                  fontFamily: "iranyekanwebmedium",
                                  fontSize: 12,
                                  color: "green",
                                }}
                              >
                                <i className="fas fa-plus-circle" />
                              </span>
                            </div>
                          )}
                        </div>
                      );
                    })}
                </div>
              )}
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <ProgressSpinner
                style={{ width: "50px", height: "50px" }}
                strokeWidth="2"
                fill="var(--surface-ground)"
                animationDuration=".5s"
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    username: state.username,
    password: state.password,
    ip: state.ip,
    account: state.account,
    place: state.place,
    fullname: state.fullname,
    tokenrb: state.tokenrb,
    mobile: state.mobile,
    appData: state.appData,
    creditPrice: state.creditPrice,
    systemId: state.systemId,
  };
}
export default connect(mapStateToProps)(Turnover);
